function CreateError(error: any) {
  let errorStr = error?JSON.stringify(error):'Что-то пошло не так.'
  return (
    <h1 className='fw-bolder text-dark mb-3'>{errorStr}</h1>
  )
}

export {CreateError}
